export default __webpack_public_path__ + "static/media/icon_range_low.53edadd7.svg";